import { Box, Button, Grid, Typography } from "@mui/material";
import { ArrowForward } from "@mui/icons-material";
import hero1 from "../../assets/taskMang.png";
import CustomText, { textStyles } from "../../components/CustomText";
import { useMediaQuery,Skeleton } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import more from "../../assets/more.svg";
import GetAppButton from "../../components/GetAppButton";
import FeaturesHeroCard from "../../components/cards/FeaturesHeroCard";
import FeaturesBigHeroCard from "../../components/cards/FeaturesBigHeroCard";
import hero3 from "../../assets/task/2.png";
import hero2 from "../../assets/task/1.png";
import hero4 from "../../assets/task/3.png";
import hero6 from "../../assets/task/4.png";
import { useEffect,useState } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import hero1es from "../../assets/spanish/Task Management/hero1es.webp";
import hero2es from "../../assets/spanish/Task Management/hero2es.webp";
import hero3es from "../../assets/spanish/Task Management/hero3es.webp";
import hero3task from "../../assets/spanish/Task Management/hero3task.png";
import hero4es from "../../assets/spanish/Task Management/hero4es.png";
import hero5es from "../../assets/spanish/Task Management/hero5es.webp";
import hero5escard from "../../assets/spanish/Task Management/hero5escard.png";
import heroimage from "../../assets/Task Management/heroimage.webp";
import herocard1 from "../../assets/Task Management/herocard1.webp";
import herocard2 from "../../assets/Task Management/herocard2.webp";
import herocard3 from "../../assets/Task Management/herocard3.png";
import herocard4 from "../../assets/Task Management/herocard4.webp";
import herocard5 from "../../assets/Task Management/herocard5.png";
import hero7 from "../../assets/report1_eng.png";
import hero7es from "../../assets/report1_spa.png";
import hero8 from "../../assets/attendence_eng.png";
import hero8es from "../../assets/attendence_spa.png";
import { BASE_URL } from "../../components/BASE_URL";
import { useSocialLinks } from "../../components/fetchGetAppUrl";

const HeroSection = () => {
  const { t, i18n } = useTranslation();
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("lg"))
  const hero_section_button_text = {
    main: "var(--Tertiary, #003149)",
    hover: "#00263a",
    contrastText: "#FFFFFF",
    fontSize: "18px",
  }
  const location = useLocation();

  useEffect(() => {
    const hash = window.location.hash;

    if (hash) {
      // Give time for DOM/rendering/layout/styles to finish
      setTimeout(() => {
        const id = hash.replace("#", "");
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 300); // Adjust timeout if needed
    }
  }, []);



  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);
  const navigate = useNavigate()
  const handleMore = () => {
    navigate("/product-tour")
  }
  const heroImageSrc = i18n.language === "es" ? hero1es : heroimage;
  const card1 = i18n.language === "es" ? hero2es : herocard1;
  const card2 = i18n.language === "es" ? hero3es : herocard2;
  const card4 = i18n.language === "es" ? hero4es : herocard3;
  const card5 = i18n.language === "es" ? hero5escard : herocard4;
  const card6 = i18n.language === "es" ? hero3task : herocard5;
  const card7 = i18n.language === "es" ? hero7es : hero7;
  const card8 = i18n.language === "es" ? hero8es : hero8;

  const parseFeatureNames = (list) => {
    try {
      const items = Array.isArray(list)
        ? list
        : list
          ? JSON.parse(list)
          : [];
      return items.map((f) => f.name);
    } catch {
      return [];
    }
  };

  const [taskHeroData, setTaskHeroData] = useState(null);
const [taskHeroLoading, setTaskHeroLoading] = useState(true);
useEffect(() => {
  const fetchTaskHeroData = async () => {
    try {
      const res = await fetch(
        `${BASE_URL}content/sections?page=1&limit=10&sort=order&include=items&search=Task_Management`
      );
      const json = await res.json();

      if (!json.error && json.data?.length > 0) {
        const section = json.data[0];

        // 🔹 Pick Spanish (idx 2) when language is ES, otherwise English (idx 0 or 1)
        const item =
          i18n.language === "es"
            ? section.items.find((it) => it.idx === 2) || section.items[0]
            : section.items.find((it) => it.idx === 0) || section.items[0];

        setTaskHeroData({
          title: item?.title || "",
          description: item?.description || "",
          url: item?.url || null,
          icon: item?.icon_image_url || null,
        });
      }
    } catch (err) {
      console.error("Error fetching Task Management hero:", err);
    } finally {
      setTaskHeroLoading(false);
    }
  };

  fetchTaskHeroData();
}, [i18n.language]); // 🔑 runs again when language changes



const [projectData, setProjectData] = useState(null);
const [projectLoading, setProjectLoading] = useState(true);




useEffect(() => {
  const fetchProjectData = async () => {
    try {
      const res = await fetch(
        `${BASE_URL}content/sections?page=1&limit=10&sort=order&include=items&search=Project_Assignment`
      );
      const json = await res.json();

      if (!json.error && json.data?.length > 0) {
        const section = json.data[0];

        const item =
          i18n.language === "es"
            ? section.items.find((it) => it.idx === 1) || section.items[0]
            : section.items.find((it) => it.idx === 0) || section.items[0];

        const parsedList = parseFeatureNames(item?.list);

        setProjectData({
          title: item?.title || "",
          description: item?.description || "",
          features: parsedList,
          url: item?.url || null,
          icon: item?.icon_image_url || null,
        });
      }
    } catch (err) {
      console.error("Error fetching Project_Assignment:", err);
    } finally {
      setProjectLoading(false);
    }
  };

  fetchProjectData();
}, [i18n.language]);


const [assignData, setAssignData] = useState(null);
const [assignLoading, setAssignLoading] = useState(true);
useEffect(() => {
  const fetchAssignData = async () => {
    try {
      const res = await fetch(
        `${BASE_URL}content/sections?page=1&limit=10&sort=order&include=items&search=Assign_Validate_Task`
      );
      const json = await res.json();

      if (!json.error && json.data?.length > 0) {
        const section = json.data[0];

        const item =
          i18n.language === "es"
            ? section.items.find((it) => it.idx === 2) || section.items[0]
            : section.items.find((it) => it.idx === 0) || section.items[0];

        const parsedList = parseFeatureNames(item?.list);

        setAssignData({
          title: item?.title || "",
          description: item?.description || "",
          features: parsedList,
        });
      }
    } catch (err) {
      console.error("Error fetching Assign_Validate_Task:", err);
    } finally {
      setAssignLoading(false);
    }
  };

  fetchAssignData();
}, [i18n.language]);




const [taskCreationData, setTaskCreationData] = useState(null);
const [taskCreationLoading, setTaskCreationLoading] = useState(true);

useEffect(() => {
  const fetchTaskCreationData = async () => {
    try {
      const res = await fetch(
        `${BASE_URL}content/sections?page=1&limit=10&sort=order&include=items&search=Task_Creation`
      );
      const json = await res.json();

      if (!json.error && json.data?.length > 0) {
        const section = json.data[0];

        const item =
          i18n.language === "es"
            ? section.items.find((it) => it.idx === 1) || section.items[0]
            : section.items.find((it) => it.idx === 0) || section.items[0];

        const parsedList = parseFeatureNames(item?.list);

        setTaskCreationData({
          title: item?.title || "",
          description: item?.description || "",
          features: parsedList,
        });
      }
    } catch (err) {
      console.error("Error fetching Task_Creation:", err);
    } finally {
      setTaskCreationLoading(false);
    }
  };

  fetchTaskCreationData();
}, [i18n.language]);




const [absenceData, setAbsenceData] = useState(null);
const [absenceLoading, setAbsenceLoading] = useState(true);

useEffect(() => {
  const fetchAbsenceData = async () => {
    try {
      const res = await fetch(
        `${BASE_URL}content/sections?page=1&limit=10&sort=order&include=items&search=Employee_Absence`
      );
      const json = await res.json();

      if (!json.error && json.data?.length > 0) {
        const section = json.data[0];

        const item =
          i18n.language === "es"
            ? section.items.find((it) => it.idx === 1) || section.items[0]
            : section.items.find((it) => it.idx === 0) || section.items[0];

        const parsedList = parseFeatureNames(item?.list);

        setAbsenceData({
          title: item?.title || "",
          description: item?.description || "",
          features: parsedList,
        });
      }
    } catch (err) {
      console.error("Error fetching Employee_Absence:", err);
    } finally {
      setAbsenceLoading(false);
    }
  };

  fetchAbsenceData();
}, [i18n.language]);



const [deptData, setDeptData] = useState(null);
const [deptLoading, setDeptLoading] = useState(true);

useEffect(() => {
  const fetchDeptData = async () => {
    try {
      const res = await fetch(
        `${BASE_URL}content/sections?page=1&limit=10&sort=order&include=items&search=Employee_Department`
      );
      const json = await res.json();

      if (!json.error && json.data?.length > 0) {
        const section = json.data[0];

        const item =
          i18n.language === "es"
            ? section.items.find((it) => it.idx === 1) || section.items[0]
            : section.items.find((it) => it.idx === 0) || section.items[0];

        const parsedList = parseFeatureNames(item?.list);

        setDeptData({
          title: item?.title || "",
          description: item?.description || "",
          features: parsedList,
        });
      }
    } catch (err) {
      console.error("Error fetching Employee_Department:", err);
    } finally {
      setDeptLoading(false);
    }
  };

  fetchDeptData();
}, [i18n.language]);

  const { links,} = useSocialLinks();


  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          justifyContent: "space-between",
          alignItems: "center",
          px: isMobile ? 2 : 8,
          py: 6,
          backgroundColor: "#fff",
          gap: 8,
          marginTop: '70px'
        }}
      >
        <Box
          sx={{
            flex: 1,
            textAlign: { xs: "center", md: "left", },

          }}
        >
          

          {taskHeroLoading ? (
  <Skeleton variant="text" width={300} height={60} />
) : (
  <CustomText
    style={{
      ...textStyles.h1,
      marginBottom: isMobile ? "0rem" : "1rem",
      marginTop: isMobile ? "0rem" : "1rem",
      fontSize: isMobile ? "36px" : "52px",
      textAlign: isMobile ? "center" : "left",
    }}
  >
    {taskHeroData?.title}
  </CustomText>
)}

{taskHeroLoading ? (
  <Skeleton variant="text" width={500} height={40} />
) : (
  <CustomText
    style={{
      ...textStyles.body1,
      color: "#868282",
      margin: "0 auto",
      marginTop: "10px",
      textAlign: isMobile ? "center" : "left",
    }}
  >
    {taskHeroData?.description}
  </CustomText>
)}

          <Box
            sx={{
              display: "flex",
              flexWrap: isMobile ? "wrap" : "nowrap",
              justifyContent: isMobile ? "center" : "flex-start",
              alignItems: "center",
              mt: isMobile ? "10px" : 4,
              gap: 1,
            }}
          >
            <GetAppButton
              label={t("get_app_now")}
              variant="primary" size="large" />
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: 0,
                cursor: "pointer",
              }}
              onClick={handleMore}
            >
              <img src={more || "/placeholder.svg"} style={{ width: "65px", height: "65px" }} />
              <p
                style={{
                  color: hero_section_button_text.main,
                  fontSize: "18px",
                  fontWeight: 600,
                  fontFamily: "Poppins, sans-serif",

                }}
              >
                {t("Learn More")}
              </p>
            </Box>
          </Box>
        </Box>

        {/* Right Section - Image */}
        <Box
          sx={{
            flex: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            mt: { xs: 4, md: 0 },
          }}
        >
          <Box
            component="img"
            src={heroImageSrc}
            alt="Dashboard Preview"
            sx={{
              width: "100%",
              maxWidth: "650px",
              height: "auto",
            }}
          />
        </Box>
      </Box>
      <Box>
      

        <Box
  id="task-scheduling-tracking"
  sx={{
    scrollMarginTop: "120px", // adjust based on your sticky header height
  }}
>
  {projectLoading ? (
    <Box sx={{ p: 3 }}>
      <Skeleton variant="text" width={250} height={40} />
      <Skeleton variant="text" width={500} height={30} />
      <Skeleton variant="rectangular" width="100%" height={150} sx={{ mt: 2 }} />
    </Box>
  ) : (
    <FeaturesBigHeroCard
      bgColor="#EFF4F8"
      image={card1}
      imagePosition="left"
      title={projectData?.title}
      description={projectData?.description}
      features={projectData?.features}
    />
  )}
</Box>


        <Box id="card2-task">
  {assignLoading ? (
    <Box sx={{ p: 3 }}>
      <Skeleton variant="text" width={250} height={40} />
      <Skeleton variant="text" width={500} height={30} />
      <Skeleton variant="rectangular" width="100%" height={150} sx={{ mt: 2 }} />
    </Box>
  ) : (
    <FeaturesHeroCard
      bgColor="#FFFFFF"
      image={card6}
      imagePosition="right"
      imageSx={{ width: "100%" }}
      title={assignData?.title}
      description={assignData?.description}
      features={assignData?.features}
    />
  )}
</Box>


       

        <Box
  id="task-biometric-validation"
  sx={{
    scrollMarginTop: "-30px", // adjust based on your sticky header height
  }}
>
  {taskCreationLoading ? (
    <Box sx={{ p: 3 }}>
      <Skeleton variant="text" width={250} height={40} />
      <Skeleton variant="text" width={500} height={30} />
      <Skeleton variant="rectangular" width="100%" height={150} sx={{ mt: 2 }} />
    </Box>
  ) : (
    <FeaturesHeroCard
      bgColor="#EFF4F8"
      image={card2}
      imagePosition="left"
      title={taskCreationData?.title}
      description={taskCreationData?.description}
      features={taskCreationData?.features}
    />
  )}
</Box>



<Box
  id="task-map-calendar-integration"
  sx={{
    scrollMarginTop: "90px", // adjust based on your sticky header height
  }}
>
  {absenceLoading ? (
    <Box sx={{ p: 3 }}>
      <Skeleton variant="text" width={250} height={40} />
      <Skeleton variant="text" width={500} height={30} />
      <Skeleton variant="rectangular" width="100%" height={150} sx={{ mt: 2 }} />
    </Box>
  ) : (
    <FeaturesBigHeroCard
      bgColor="#FFFFFF"
      image={card8}
      imagePosition="right"
      title={absenceData?.title}
      description={absenceData?.description}
      features={absenceData?.features}
    />
  )}
</Box>

        <Box
  id="task-reporting-metrics"
  sx={{
    scrollMarginTop: "20px", // adjust based on your sticky header height
  }}
>
  {deptLoading ? (
    <Box sx={{ p: 3 }}>
      <Skeleton variant="text" width={250} height={40} />
      <Skeleton variant="text" width={500} height={30} />
      <Skeleton variant="rectangular" width="100%" height={150} sx={{ mt: 2 }} />
    </Box>
  ) : (
    <FeaturesBigHeroCard
      bgColor="#EFF4F8"
      image={card7}
      imagePosition="right"
      title={deptData?.title}
      description={deptData?.description}
      features={deptData?.features}
    />
  )}
</Box>

      </Box>
    </>
  );
}
export default HeroSection
